import { useCallback } from 'react';
import { SessionInput, updateSessionFields } from '../../services/sessions';
import { Session } from '../../services/sessionModels';
import { refreshSession } from '../Util/useSession';

export type Update = SessionInput;

export function useUpdateSession() {
  const updateFunc = useCallback(async (update: Update, session?: Session | null) => {
    if (!session) return;
    await updateSessionFields(session, update);
    await refreshSession(session.id);
  }, []);
  return [updateFunc];
}
